
export default {
  props: {
    name: String,
    modalKey: String,
    message: String | null,
    title: String | null,
    okButtonText: String | null,
    cancelButtonText: String | null,
  },
};
